import React from 'react'
import Layout from '../../components/home/Layout'

export const Home = () => {
  return <Layout />
}

export default Home
